import { AppConfig } from "./interfaces/app-config";

export const globalConfig: AppConfig = {
    pages: {
        login: {
            title: 'Iniciar sesión',
            subtitle: 'Introduzca su correo electrónico y contraseña para iniciar sesión',
            form: {
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                rememberMe: {
                    label: 'Recordarme'
                },
            },
            socialAuth: 'O inicia sesión con',
            forgotPassword: '¿Ha olvidado su contraseña?',
            submit: 'Iniciar sesión',
            nextAuth: {
                question: '¿No tienes cuenta?',
                action: 'Registrate aquí'
            }
        },
        register: {
            title: 'Registrate',
            subtitle: 'Introduzca sus datos personales para crear una cuenta',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                terms: {
                    label: 'Acepto los ',
                    action: 'términos y condiciones'
                }
            },
            socialAuth: 'O registrate con',
            submit: 'Registrarse',
            nextAuth: {
                question: '¿Ya tienes una cuenta?',
                action: 'Inicia sesión'
            }
        },
        account: {
            title: 'Mi Cuenta'
        },

        users: {
            titlePlural: 'Usuarios',
            titleSingular: 'Usuario',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                image: {
                    label: 'Imagen',
                    placeholder: 'Selecciona una imagen'
                }
            }
        },
        customer: {
            titlePlural: 'Registrados',
            titleSingular: 'Registro',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                image: {
                    label: 'Imagen',
                    placeholder: 'Selecciona una imagen'
                }
            }
        },
        profile: {
            titlePlural: 'Perfiles',
            titleSingular: 'Perfil',
            form: {}
        },
        historyTickets: {
            titlePlural: 'Historial',
            titleSingular: 'Historial',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar',
                    placeholder: 'Escribir...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar...'
                },
            }
        },
        location: {
            titlePlural: 'Predios',
            titleSingular: 'Predio',
            form: {
                name: {
                    label: 'Nombre',
                    placeholder: 'Ingresa tu nombre completo'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Ingresa dirección'
                },
                zona: {
                    label: 'Zona',
                    placeholder: 'Ingresa tu zona'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Selecciona...'
                },
                country: {
                    label: 'Pais',
                    placeholder: 'Selecciona...'
                },
                latitude: {
                    label: 'Latidud',
                    placeholder: 'Selecciona...'
                },
                longitude: {
                    label: 'Longitud',
                    placeholder: 'Selecciona...'
                },
            },
            form_sector: {
                name: {
                    label: 'Nombres del sector',
                    placeholder: 'Ingresa nombre'
                },
                image: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                description: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                cant: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                doors: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
                status: {
                    label: 'Imagen del sector',
                    placeholder: 'Imagen del sector'
                },
            },

        },
        events: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form:{},
            form_filter:{
                search: {
                    label:'Buscar',
                    placeholder: 'Buscar...'
                }
            }
        },
        eventsBilling: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form:{},
        },
        eventsServiceFree: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form:{},
        },
        eventsPlaform: {
            titlePlural: 'Eventos',
            titleSingular: 'Evento',
            form:{},
        },
        tickets: {
            titlePlural: 'Entradas',
            titleSingular: 'Entrada',
            form:{},
        },
        mailing: {
            titlePlural: 'Notificaciones',
            titleSingular: 'Notificación',
            form:{},
        },
        sendMail: {
            titlePlural: 'Notificaciones',
            titleSingular: 'Notificación',
            form:{},
        },
        exihibition: {
            titlePlural: 'Exibiciones',
            titleSingular: 'Exibición',
            form:{},
        },
        types: {
            titlePlural: 'Tipos de Eventos',
            titleSingular: 'Tipo de Evento',
            form:{},
        },
        access: {
            titlePlural: 'Accesos',
            titleSingular: 'Acceso',
            form:{},
        },
        institutions: {
          titlePlural: 'Instituciones',
          titleSingular: 'Institución',
          form:{},
        },
        category: {
          titlePlural: 'Ctegorias',
          titleSingular: 'Categoria',
          form:{},
        },
        accreditations: {
          titlePlural: 'Acreditaciones',
          titleSingular: 'Acreditación',
          form:{},
        },
        uploadFile: {
          titlePlural: 'Subir datos',
          titleSingular: 'Subir dato',
          form:{},
        },
        uploadFile2: {
          titlePlural: 'Subir Instituciones',
          titleSingular: 'Subir Intitución',
          form:{},
        },
        assistance: {
            titlePlural: 'Asistencias',
            titleSingular: 'Asistencia',
            form:{},
        },
        promotions: {
          titlePlural: 'Promociones',
          titleSingular: 'Promoción',
          form:{
            name:{
              label: 'Nombre',
              placeholder: 'Escribir nombre...'
            },
            description:{
              label: 'Descripción',
              placeholder: 'Escribir...'
            },
            status:{
              label: 'Estado',
              placeholder: 'Seleccionar...'
            },
            date:{
              label: 'Fecha de inicio',
              placeholder: 'Escribir...'
            },
            dateEnd:{
              label: 'Fecha fin',
              placeholder: 'Escribir...'
            },
            time:{
              label: 'Hora de inicio',
              placeholder: 'Escribir...'
            },
            timeEnd:{
              label: 'Hora fin',
              placeholder: 'Escribir...'
            },
            limit:{
              label: 'Limite por usuarios',
              placeholder: 'Escribir...'
            },
            limitGral:{
              label: 'Limite total de rendiciones',
              placeholder: 'Escribir...'
            },
            minutes:{
              label: 'Minutos',
              placeholder: 'Escribir...'
            },
            channels:{
              label: 'Canal',
              placeholder: 'Escribir...'
            },
            sigla:{
              label: 'Sigla',
              placeholder: 'Escribir...'
            },
            quantity:{
              label: 'Cantidad de usos del cupon',
              placeholder: 'Escribir...'
            },
            quantityBuy:{
              label: 'Cantidad de compra',
              placeholder: 'Escribir...'
            },
            quantityPaid:{
              label: 'Cantidad de pago',
              placeholder: 'Escribir...'
            },
            // textCustom:{
            //   label: 'codigo promoccional',
            //   placeholder: 'Escribir...'
            // },
            text:{
              label: 'Código promocional personalizado',
              placeholder: 'Escribir...'
            },
            percentage:{
              label: 'Porcentaje',
              placeholder: 'Escribir...'
            },
            total:{
              label: 'Total',
              placeholder: 'Escribir...'
            },
            userCustom:{
              label: 'Activar segmerntacion de usuarios ',
              placeholder: 'Escribir...'
            },

          },
        },
        forgetPassword: {
          title: 'Recuperar contraseña',
          subtitle: 'Introduzca correo electronico de registro.',
          form: {
            code: {
              label: 'Código',
              placeholder: 'Escribir código...',
              action: 'Ingresa el código enviado a su correo de recuperación'
            },
            email: {
              label: 'Correo electrónico',
              placeholder: 'Ingresa tu correo electrónico',
              action: "Ingresa el correo con el que te registraste para recuperar tu contraseña"
            },
            password: {
              label: 'Contraseña',
              placeholder: 'Ingresa tu contraseña',
              action: "Ingrese una nueva contraseña, como mínimo debe tener 8 caracteres"
            },
            passwordConfir: {
              label: 'Confirmar contraseña',
              placeholder: 'Confirmar contraseña...'
            },
            passwordCurrent: {
              label: 'Contraseña actual',
              placeholder: 'Escribir contraseña...'
            }
          },
          socialAuth: 'O registrate con',
          submit: 'Registrarse',
          nextAuth: {
            question: '',
            action: 'Ir a Inicia sesión'
          }
        },

      // DASHBOARD
      dashboard: {
        titlePlural: 'Dashboard',
        titleSingular: 'Dashboard',
        title: 'Dashboard',
        form:{},
      },
    },
      validations: {
        required: "El campo \"{label}\" es requerido.",
        number: "El campo \"{label}\" debe contener solo números.",
        minlength: "El campo \"{label}\" debe tener al menos \"{requiredLength}\" caracteres.",
        maxlength: "El campo \"{label}\" debe tener un máximo de \"{requiredLength}\" caracteres.",
        min: "El campo \"{label}\" debe contener al menos \"{min}\" elementos.",
        max: "El campo \"{label}\" debe tener un máximo de \"{max}\" elementos.",
        email: "El campo \"{label}\" debe ser un email válido.",
        default: "El campo \"{label}\" es inválido.",
    },
    menu: [
        {
            headTitle1: "General",
        },
        {
            id: 1,
            level: 1,
            path: '/account',
            title: "Mi Cuenta",
            icon: "home",
            type: "link",
        },
        {
            id: 1,
            level: 1,
            path: '/dashboard',
            title: "Dashboard",
            icon: "home",
            type: "link",
        },
        {
            headTitle1: "Páginas",
        },
        {
            id: 2,
            level: 1,
            path: "/users",
            title: "Usuarios",
            icon: "user",
            type: "link",
        },
        {
            headTitle1: "Predios",
        },
        {
            id: 2,
            level: 1,
            path: '/location/create',
            title: "Crear predios",
            icon: "bookmark",
            type: "link",
        },
        {
            id: 3,
            level: 1,
            path: '/location',
            title: "Predios habilitados",
            icon: "bookmark",
            type: "link",
        },
        {
            id: 4,
            level: 1,
            path: '/location/list-archived',
            title: "Predios archivados",
            icon: "bookmark",
            type: "link",
        },
        {
            headTitle1: "Eventos",
        },
        {
            id: 4,
            level: 1,
            path: 'event/list-category',
            title: "Categorias",
            icon: "bookmark",
            type: "link",
        },
        {
            id: 4,
            level: 1,
            path: '/event',
            title: "Eventos actuales",
            icon: "bookmark",
            type: "link",
        },
        {
            id: 4,
            level: 1,
            path: 'event/list-past',
            title: "Eventos pasados",
            icon: "bookmark",
            type: "link",
        },
        {
            id: 4,
            level: 1,
            path: 'event/list-exhibitions',
            title: "Exibiciones",
            icon: "bookmark",
            type: "link",
        },

        {
            headTitle1: "Tickets",
            permissions:'organization-title-tickets',
        },
        {
            id: 5,
            level: 1,
            path: 'history-tickets',
            title: "Reportes de entradas",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-history_tickets',
        },
        {
            id: 5,
            level: 1,
            path: 'assistance',
            title: "Reporte de asistencia",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-assistance',
        },

    ],
    horizontalMenu: [
      {
          id: 1,
          level: 1,
          path: '/dashboard',
          title: "Dashboard",
          icon: "home",
          type: "link",
          permissions:'tickets-page-dashboard',
      },
    ],
};
